export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      backgroundImage: 'none !important',
      display: 'block',
      position: 'relative',
      height: 'initial',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  mainTitle: {
    zIndex: 2,
    position: 'absolute',
    top: '7%',
    left: '5%',
    width: '33%',
    color: theme.palette.blue.main,
    [theme.breakpoints.down('md')]: {
      color: theme.palette.teal.dark,
      position: 'relative',
      top: 0,
      left: 0,
      textAlign: 'center',
      padding: theme.spacing(4),
      margin: '0',
      width: '100%',
    },
  },
  column: {
    display: 'flex',
    alignItems: 'flex-start',
    position: 'absolute',
    left: '40%',
    top: 'calc(50% - 28px)',
    transform: 'translateY(-50%)',
    width: '60%',
    '& > *': {
      flex: 1,
    },
    [theme.breakpoints.down('md')]: {
      transform: 'initial',
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
    },
  },
  digitsL: {
    width: '28%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.palette.blue.dark,
    [theme.breakpoints.down('md')]: {
      transform: 'initial',
      textAlign: 'center',
      backgroundColor: theme.palette.blue.main,
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
      margin: 0,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  digitsR: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.palette.white.main,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      transform: 'initial',
      textAlign: 'center',
      backgroundColor: theme.palette.teal.ultradark,
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  columnDir: {
    display: 'block !important',
  },
  digit: {
    padding: theme.spacing(2),
    '&:first-child': {
      paddingBottom: '10px',
    },
    '&:last-child': {
      paddingTop: '10px',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 'initial',
    },
    '& .title1': {
      backgroundColor: theme.palette.white.main,
      color: theme.palette.blue.main,
    },
    '& .subtitle1': {
      fontWeight: '700',
      fontSize: '1rem',
    },
    '& .subtitle2': {
      fontWeight: 'bold',
    },
  },
  numberWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '5px',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  digitTitleL: {
    marginBottom: theme.spacing(1),
    display: 'inline-block',
    color: theme.palette.white.main,
    backgroundColor: theme.palette.teal.ultralight,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    '& > .title1': {
      width: '100%',
    },
  },
  digitTitleR: {
    marginBottom: theme.spacing(1),
    display: 'inline-block',
    color: theme.palette.white.main,
    backgroundColor: theme.palette.teal.ultralight,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  digitNumberL: {
    color: theme.palette.white.main,
    fontSize: '1.8rem',
    fontWeight: 'bold',
    flexShrink: 0,
  },
  digitNumberR: {
    color: theme.palette.white.main,
    fontSize: '1.8rem',
    fontWeight: 'bold',
    flexShrink: 0,
  },
  digitDescL: {
    color: theme.palette.white.main,
    fontWeight: '300',
    width: '80%',
    [theme.breakpoints.down('md')]: {
      width: 'initial',
    },
  },
  digitDescR: {
    color: theme.palette.white.main,
    fontWeight: '300',
    [theme.breakpoints.down('md')]: {
      width: 'initial',
    },
  },
});
